module.exports = __webpack_public_path__ + "static/media/plansza_informacyjna_PFR.cf475167.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/plansza_informacyjna_PFR.jpg
// module id = 631
// module chunks = 0